import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';
import { PrintDocumentService } from '../../../../print-documents/print-document.service';
import { CustomBarChartComponent } from '../../../../shared/components/custom-bar-chart/custom-bar-chart.component';
import { PrintFilterDataComponent } from '../../../../shared/components/print-filter-data/print-filter-data.component';
import { AlertService } from '../../../../shared/services/alert.service';
import {
  DocumentTypeEnum,
  ExportToPdfService,
} from '../../../../shared/services/export-to-pdf.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { ReportFilterService } from '../../../../shared/services/report-filter.service';
import { AnalyticalReportService } from '../../../../shared/services/reporting-services/analytical-report.service';
import { ChartTypeColorsEnum } from '../../../../utils/enums/chart-colors.enum';
import { IReportFilter } from '../../../../utils/interfaces/report-filter';
import { IAnswerDetail } from '../../../../utils/interfaces/summary-report';

@Component({
  selector: 'app-analytical',
  standalone: true,
  imports: [CommonModule, PrintFilterDataComponent, CustomBarChartComponent],
  templateUrl: './analytical.component.html',
  styleUrl: './analytical.component.scss',
})
export class AnalyticalComponent {
  print = false;
  chartColorsEnum = ChartTypeColorsEnum;
  private readonly unsubscribe$ = new Subject();

  private readonly alertService = inject(AlertService);

  filter: IReportFilter | null = null;

  data!: { average: number; total: number; analyticalData: IAnswerDetail[] };

  constructor(
    private readonly reportFilterService: ReportFilterService,
    private readonly analyticalReportService: AnalyticalReportService,
    private readonly loadingService: LoadingService,
    private readonly exportToPdfService: ExportToPdfService,
    private readonly printDocumentService: PrintDocumentService
  ) {
    effect(
      () => {
        this.printDocument(exportToPdfService.getDocumentType());
      },
      {
        allowSignalWrites: true,
      }
    );
    effect(
      () => {
        this.filter = reportFilterService.getFilter();
        this.getReportData();
      },
      {
        allowSignalWrites: true,
      }
    );
  }

  getReportData(): void {
    if (!this.filter) return;

    if (this.filter.branchesId.length <= 1) {
      this.alertService.warning(
        'Para gerar o relatório analítico, é necessário selecionar no mínimo duas unidades.'
      );
      return;
    }

    setTimeout(() => {
      this.loadingService.showLoading();
    }, 0);

    this.analyticalReportService
      .getAnalyticalReport(this.filter)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.data = res.data;

        this.loadingService.closeLoading();
      });
  }

  printDocument(document: DocumentTypeEnum | null): void {
    if (!document || !this.data) {
      this.exportToPdfService.generatePDF(null);
      return;
    }

    this.printDocumentService.printDocument(DocumentTypeEnum.analytical, {
      data: this.data,
      filter: this.filter,
    });
    this.exportToPdfService.generatePDF(null);
  }
}
